import ApplicationSerializer from 'eflex/serializers/application';

export default class EdhrMappingSerializer extends ApplicationSerializer {
  attrs = {
    edhrTrigger: {
      serialize: false,
      deserialize: false,
    },
    task: {
      serialize: false,
      deserialize: false,
    },
  };
}
